var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-labeled-checkbox"},[_c('VCheckbox',_vm._b({attrs:{"name":"$attrs.label"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'VCheckbox',_vm.$attrs,false)),_c('label',{attrs:{"for":_vm.$attrs.label}},[_vm._v(" "+_vm._s(_vm.$attrs.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }